const convertToPx = (value: number) => `${value}px`;

export function typography(fontSize: number | number[], lineHeight: number | number[], fontWeight?: number | number[]) {
    return {
        fontSize,
        lineHeight: Array.isArray(lineHeight) ? lineHeight.map(convertToPx) : convertToPx(lineHeight),
        fontWeight,
    };
}
